var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-competency-distribution"},[_c('v-chart',{style:({ width: '100%', height: _vm.height + 'px' }),attrs:{"options":_vm.chartOptions,"auto-resize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }